import loadable from '@loadable/component';

export const OnlineBookingProfileLoadable = loadable(() => import('./OnlineBookingProfile'), {
  fallback: undefined,
});
